export const DESKTOP_MIN_WIDTH = 768;

export const MOBILE_MAX_WIDTH = DESKTOP_MIN_WIDTH + 1;
export const NUMBER_OF_ROW = 4;
export const CLEAR_BUTTON_LABEL = 'Clear Button';
export const SEARCH_OR_SELECT = 'Search or select one';
export const ALL_PRODUCTS = 'All products';
export const SEARCH_OR_SELECT_ERROR = 'Search or select a product.';
